var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state.appStage.currentProgress === 'lookup')?_c('MembershipType'):_vm._e(),(_vm.state.appStage.currentProgress === 'app')?_c('Application'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }